import { APIError, APIResponseModel, FileApiResponse, FileFormInputModel, HFWApiError, HFWUnAuthorizedError } from '@models/api';


export class BrowserBaseClient {
  constructor(protected apiBaseUrl: string) {}

  protected async createAuthenticatedRequest(url: string, options: RequestInit = {}): Promise<Request> {
    const headers = new Headers(options.headers);
    headers.set('Content-Type', 'application/json');

    // Include credentials to send cookies
    return new Request(url, {
      ...options,
      headers,
      credentials: 'include',
    });
  }

  protected async createRequest(url: string, options: RequestInit = {}): Promise<Request> {
    const headers = new Headers(options.headers);
    headers.set('Content-Type', 'application/json');

    return new Request(url, {
      ...options,
      headers,
    });
  }

  protected async get<T>(url: string, options: Omit<RequestInit, 'method'> = {}): Promise<APIResponseModel<T>> {
    const request = await this.createAuthenticatedRequest(url, {
      ...options,
      method: 'GET',
    });
    const response = await fetch(request);
    return this.processResponse(response);
  }

  protected async post<K extends object, T>(url: string, data: K, options: Omit<RequestInit, 'method' | 'body'> = {}): Promise<APIResponseModel<T>> {
    const request = await this.createAuthenticatedRequest(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),      
    });
    const response = await fetch(request);

    return this.processResponse(response);
  }

  protected async delete<T>(url: string, options: Omit<RequestInit, 'method'> = {}): Promise<APIResponseModel<T>> {
    const request = await this.createAuthenticatedRequest(url, {
      ...options,
      method: 'Delete',
    });
    const response = await fetch(request);
    return this.processResponse(response);
  }

  protected async uploadFormFile(url: string, fileInput: FileFormInputModel ): Promise<APIResponseModel<FileApiResponse>> {

    const formData = new FormData();
    formData.append('file', fileInput.file, fileInput.fileName);
    formData.append('path', fileInput.path);
    formData.append('fileName', fileInput.fileName)
        
    var request = new Request(url, {            
      credentials: 'include',
      method: 'POST',
      body: formData,
    });
    

    const response = await fetch(request);

    return this.processResponse(response);
  }

  protected async publicGet<T>(url: string, options: Omit<RequestInit, 'method'> = {}): Promise<APIResponseModel<T>> {
    const request = await this.createRequest(url, {
      ...options,
      method: 'GET',
    });
    const response = await fetch(request);
    return this.processResponse(response);
  }

  protected async publicPost<K extends object, T>(url: string, data: K, options: Omit<RequestInit, 'method' | 'body'> = {}): Promise<APIResponseModel<T>> {
    const request = await this.createRequest(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),
    });
    const response = await fetch(request);

    return this.processResponse(response);
  }

  private async processResponse<T>(resp: Response): Promise<APIResponseModel<T>> {
    let apiError = {
      validationErrors: [],
      errorMessage: '',
      status: 0,
    } as APIError;

    switch (resp.status) {
      case 200:
        const result = await resp.json();
        // return result.data;
        return {
          data: result.data,
          message: result.message,
          success: result.success,
          errors: [],
        } as APIResponseModel<T>;
      case 401:
        throw new HFWUnAuthorizedError(resp.statusText);
      default:
        let error: any;
        try {
          error = JSON.parse(await resp.text());
        } catch {
          error = await resp.text();
        }
        apiError = {
          validationErrors: error.errors,
          errorMessage: error.message,
          status: resp.status,
        } as APIError;
        throw new HFWApiError(apiError);
    }
  }
}
